import lodash from 'lodash'
import React from 'react'
import styled from 'styled-components'

import Alert from '../../../../../../1stlog-ui/src/components/Alert'
import { useField } from '../../../../../../1stlog-ui/src/components/Field'
import { useProducts } from '../../../Products'
import ManualDisposition from '../ManualDisposition'
import useProvider from '../useProvider'
import useRelevantTransportFields from '../useRelevantTransportFields'
import ProductGroup from './ProductGroup'
import ProductValidation from './ProductValidation'

const Wrapper = styled.div`
  // margin: 0 -11px -10px -11px;
`

const ProductSelect = (props) => {
  const { isPickup } = props

  const { products } = useProducts()

  const isManualDisposition = useField('isManualDisposition')

  const {
    date,
    provider,
    pickupCountry,
    pickupZip,
    deliveryCountry,
    deliveryZip,
  } = useRelevantTransportFields()

  let message

  if (!date) {
    message = i18n.t('please_specify_date', 'Bitte geben Sie ein Datum an')
  }

  if (!pickupCountry || !pickupZip) {
    message = i18n.t('please_specify_sender', 'Bitte geben Sie den Absender an')
  }

  if (!deliveryCountry || !deliveryZip) {
    message = i18n.t(
      'please_specify_recipient',
      'Bitte geben Sie den Empfänger an',
    )
  }

  const providerObject = useProvider()

  const { notAllowed, dispositionOnly } = providerObject || {}

  if (!provider) {
    message = i18n.t(
      'please_enter_service_provider',
      'Bitte geben Sie den Dienstleister an',
    )
  }

  return (
    <Wrapper>
      <div className="mt-n1 mb-2">
        <ManualDisposition />
      </div>
      {!notAllowed && !isManualDisposition && (
        <div className="mb-2 mt-2">
          <strong>
            {dispositionOnly
              ? i18n.t('dispatching_options', 'Disponierungsmöglichkeiten')
              : i18n.t(
                  'products_for_this_day',
                  'Versandmöglichkeiten für diesen Tag',
                )}
          </strong>
        </div>
      )}

      {!isManualDisposition && (
        <>
          {message && <Alert info>{message}</Alert>}

          <ProductValidation hide={!!message} />

          {notAllowed && (
            <Alert warning className="mt-1">
              {i18n.t(
                'provider_not_yet_activated_reach_out_to_administrator',
                'Dieser Dienstleister wurde für Sie noch nicht freigeschaltet. Bitte wenden Sie sich an Ihren Administrator.',
              )}
            </Alert>
          )}

          {lodash.isEmpty(products) && !message && !notAllowed && (
            <Alert warning>
              {i18n.t(
                'no_more_shipping_options_for_chosen_day2',
                'Keine Versandmöglichkeiten für den gewählten Tag verfügbar. Bitte kontaktieren Sie Ihren Versandpartner für weitere Versandoptionen.',
              )}
            </Alert>
          )}

          {/* <Row>
            <Col>
              <ProductValidator />
            </Col>
          </Row> */}
          {/* normal 1stlog products for now */}
          <ProductGroup products={products} isPickup={isPickup} />

          {/* <ProductGroup title="Der Kurier" products={products} />
      <ProductGroup title="DHL" products={[]} />
      <ProductGroup title="UPS" products={[]} /> */}
          {/* {dispositionOnly && (
            <FieldPrefix name="productSettings">
              <CustomPrice />
            </FieldPrefix>
          )} */}
        </>
      )}
    </Wrapper>
  )
}

export default ProductSelect
